import ApprovalTimelineReadonly from './ApprovalTimelineReadonly';
import HeaderIjin from './HeaderIjin';

const CardIjinReadonly = ({ item }) => {
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 12,
        padding: 20,
        marginBottom: 16,
        border: '1px solid #f0f0f0',
        marginLeft: 0,
        marginRight: 0,
      }}
    >
      <HeaderIjin item={item} />
      <hr style={{ border: 'none', borderTop: '1px solid #e5e7eb', margin: '10px 0' }} />
      <ApprovalTimelineReadonly item={item} />

    </div>
  );
};

export default CardIjinReadonly;